import React from "react";

import {
  computeShiftActivationUrgency as computeShiftLifecycle,
} from "../core/shifts/shiftLifecycle";
import {
  getShiftOperationalSummary,
} from "../core/shifts/shiftOperationalSummary";

function toneForStage(
  stage,
  operational = {}
) {
  const s = String(stage || "").toLowerCase();

  if (s === "arrived") {
    return {
      bg: "#ecfdf5",
      border: "#bbf7d0",
      text: "#166534",
      dot: "#22c55e",
      label: "Arrived",
    };
  }

  if (s === "completed") {
    return {
      bg: "#f8fafc",
      border: "#e2e8f0",
      text: "#475569",
      dot: "#94a3b8",
      label: "Completed",
    };
  }

  if (s === "activated") {
    return {
      bg: "#eff6ff",
      border: "#bfdbfe",
      text: "#1d4ed8",
      dot: "#3b82f6",
      label: "Activated",
    };
  }

    if (s === "tracking") {
    return {
      bg: "#f5f3ff",
      border: "#ddd6fe",
      text: "#6d28d9",
      dot: "#8b5cf6",
      label: "En Route",
    };
  }

   if (s === "assigned") {
    if (
      operational
        ?.awaitingAcceptance
    ) {
      return {
        bg: "#fff7ed",
        border: "#fed7aa",
        text: "#9a3412",
        dot: "#f97316",
        label:
          "Awaiting Acceptance",
      };
    }

    return {
      bg: "#eef2ff",
      border: "#c7d2fe",
      text: "#4338ca",
      dot: "#6366f1",
      label:
        operational?.accepted
          ? "Accepted"
          : "Assigned",
    };
  }

  if (s === "critical") {
    return {
      bg: "#fff7ed",
      border: "#fdba74",
      text: "#9a3412",
      dot: "#f97316",
      label: "Critical",
    };
  }

  if (s === "warning") {
    return {
      bg: "#fffbeb",
      border: "#fde68a",
      text: "#92400e",
      dot: "#f59e0b",
      label: "Warning",
    };
  }

  if (s === "active") {
    return {
      bg: "#eff6ff",
      border: "#bfdbfe",
      text: "#1d4ed8",
      dot: "#3b82f6",
      label: "Active",
    };
  }

  return {
    bg: "#f8fafc",
    border: "#e2e8f0",
    text: "#64748b",
    dot: "#94a3b8",
    label: "Pending",
  };
}

export default function LifecycleBoxes({ shift, now = Date.now(), count = 3 }) {
   const operational =
    getShiftOperationalSummary(
      shift
    );

  const statusName =
    operational.status;

  const stage =
    [
      "completed",
      "arrived",
      "tracking",
      "activated",
      "assigned",
    ].includes(statusName)
      ? statusName
      : computeShiftLifecycle(
          shift,
          now,
          2
        );

  const tone =
    toneForStage(
      stage,
      operational
    );
  const items = Array.from({ length: count });

  return (
    <div style={{ display: "flex", gap: 4, alignItems: "center", flexWrap: "wrap" }}>
      {items.map((_, i) => (
        <span
          key={i}
          title={tone.label}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 18,
            height: 18,
            padding: "0 6px",
            borderRadius: 999,
            background: tone.bg,
            border: `1px solid ${tone.border}`,
            boxShadow: "inset 0 1px 0 rgba(255,255,255,.65)",
          }}
        >
          <span
            style={{
              width: 5,
              height: 5,
              borderRadius: 999,
              background: tone.dot,
              display: "inline-block",
            }}
          />
        </span>
      ))}

      <span
        style={{
          fontSize: 10,
          fontWeight: 800,
          color: tone.text,
          marginLeft: 1,
          letterSpacing: 0.15,
        }}
      >
        {tone.label}
      </span>
    </div>
  );
}